export default "__VITE_PUBLIC_ASSET__95cd4fde__"